export enum PremiumType {
    Casco = 'casco',
    Mtpl = 'mtpl',
    CascoMtpl = 'casco_mtpl',
}
